import React from "react";
import styled from "styled-components";
import { Avatar } from "@sonder/ui/source/styled/components/Avatar";
import { Dropdown } from "@sonder/ui/source/styled/components/Dropdown";
import { DropdownContent } from "@sonder/ui/source/styled/components/DropdownContent";
import { Button } from "@sonder/ui/source/styled/fragments/Button";
import { SidebarButton } from "@sonder/ui/source/styled/fragments/Sidebar";

const UserMenuDropdownContent = styled(DropdownContent)`
  flex-direction: column;
  left: 0.5rem;
  min-width: 18rem;
`;

const UserMenuDropdownOption = styled(Button)`
  justify-content: flex-start;
`;

export interface RenderTriggerArgs {
  onClear?(): void;
}

interface UserMenuProps {
  className?: string;
  loading?: boolean;
  onClose?(): void;
  onOpen?(): void;
  onEditProfile?(): void;
  onLogout?(): void;
  renderTrigger: (args?: RenderTriggerArgs) => JSX.Element;
}

interface UserMenuTriggerProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  imageUrl?: string | null;
  name?: string;
}

export const UserMenuTrigger = ({
  imageUrl,
  name,
  ...rest
}: UserMenuTriggerProps) => (
  <SidebarButton {...rest}>
    <Avatar imageUrl={imageUrl} name={name} />
  </SidebarButton>
);

export const UserMenu = ({
  className,
  loading,
  onClose = () => undefined,
  onOpen = () => undefined,
  onEditProfile = () => undefined,
  onLogout = () => undefined,
  renderTrigger,
}: UserMenuProps) => (
  <Dropdown
    className={className}
    trigger={renderTrigger()}
    onClose={onClose}
    onOpen={onOpen}
  >
    {({ isOpen, closePortal }) =>
      isOpen && (
        <UserMenuDropdownContent>
          <UserMenuDropdownOption
            noBorder
            disabled={loading}
            onClick={() => {
              closePortal();
              onEditProfile();
            }}
          >
            Edit profile
          </UserMenuDropdownOption>
          <UserMenuDropdownOption
            noBorder
            data-cy="LogoutButton"
            onClick={() => {
              closePortal();
              onLogout();
            }}
          >
            Sign out
          </UserMenuDropdownOption>
        </UserMenuDropdownContent>
      )
    }
  </Dropdown>
);
